import React from 'react';
import PageTitle from '../layout/PageTitle';

const Privacy: React.FC = () => {
  return (
    <div className="content">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <PageTitle title="Privacy Policy" />

        <div className="bg-brand-card/60 backdrop-blur-md border border-brand-border rounded-xl p-6 md:p-8 space-y-6 text-white/80 text-sm leading-relaxed">
          <h1 className="text-2xl font-bold text-white mb-4">Privacy Policy</h1>
          <p className="text-white/60 text-xs">Last updated: January 2026</p>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">1. Information We Collect</h2>
            <p>
              We collect information you provide directly (e.g., email when signing up), information from your use of the Service (e.g., pages visited, features used), and technical data (e.g., IP address, browser type, device information). We may use cookies and similar technologies.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">2. How We Use Your Information</h2>
            <p>
              We use collected information to: provide and improve the Service, process transactions, send transactional communications, analyze usage patterns, and comply with legal obligations. We do not sell your personal information to third parties.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">3. Data Sharing</h2>
            <p>
              We may share data with: service providers who assist in operating the Service (under confidentiality agreements), legal authorities when required by law, and in connection with a merger or sale of assets. We do not share personal data for third-party marketing.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">4. Data Retention</h2>
            <p>
              We retain your data for as long as your account is active or as needed to provide the Service. We may retain certain data for legal, regulatory, or legitimate business purposes after account closure.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">5. Security</h2>
            <p>
              We implement reasonable measures to protect your data. However, no method of transmission or storage is 100% secure. We cannot guarantee absolute security.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">6. Your Rights</h2>
            <p>
              Depending on your jurisdiction, you may have rights to access, correct, delete, or port your data, and to object to or restrict certain processing. Contact us to exercise these rights. You may also unsubscribe from marketing emails at any time.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">7. Children</h2>
            <p>
              The Service is not intended for individuals under 18. We do not knowingly collect data from children. If you believe we have collected data from a child, contact us immediately.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">8. International Transfers</h2>
            <p>
              Your data may be transferred to and processed in countries other than your own. By using the Service, you consent to such transfers.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">9. Changes</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of material changes by posting the updated policy and updating the “Last updated” date.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">10. Contact</h2>
            <p>
              For privacy-related questions or requests, contact us via our website or support channels.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
